// extracted by mini-css-extract-plugin
export default {"modal":"JX-z","overlay":"KX-z","outfitSelector":"LX-z","outfitHeading":"MX-z","itemContainer":"NX-z","item":"OX-z","selected":"PX-z"};